<template>
  <VLayout pa-4>
    <template v-if="!error">
      <VFlex xs6 style="height: 100vh">
        <Viewer
          v-if="invoice && invoice.file_url"
          id="external-approval"
          :file="invoice.file_url"
          :fileName="invoice.file_name"
        />
      </VFlex>

      <VFlex xs6>
        <VCard style="max-width: 600px; margin: 0 auto">
          <VLayout justify-space-around align-center row fill-height>
            <VFlex xs12 pa-4>
              <VCardTitle style="padding-left: 0; font-variant: small-caps">
                <h1>Potrebna je potrditev dokumenta</h1>
              </VCardTitle>

              <VCard flat class="pa-3 grey lighten-4">
                <VList>
                  <VListTile>
                    <VListTileContent>
                      <VListTileTitle
                        ><strong>Ime datoteke:</strong> {{ invoice.file_name }}</VListTileTitle
                      >
                    </VListTileContent>
                  </VListTile>

                  <VListTile>
                    <VListTileContent>
                      <VListTileTitle
                        ><strong>Pošiljatelj:</strong> {{ invoice.sender_email }}</VListTileTitle
                      >
                    </VListTileContent>
                  </VListTile>
                </VList>
              </VCard>

              <VLayout row wrap justify-space-around pa-3>
                <VBtn large color="success" :loading="processing" @click="handleApproval(true)">
                  <VIcon>check</VIcon>
                  Potrdi dokument
                </VBtn>
                <VBtn large color="error" :loading="processing" @click="handleApproval(false)">
                  <VIcon>close</VIcon>
                  Zavrni dokument
                </VBtn>
              </VLayout>

              <VAlert v-if="successMessage" type="success" :value="true" class="pa-3">
                {{ successMessage }}
              </VAlert>
            </VFlex>
          </VLayout>
        </VCard>
      </VFlex>
    </template>

    <VFlex v-else xs12>
      <VCard style="max-width: 600px; margin: 0 auto">
        <VAlert type="error" :value="true">
          {{ error }}
        </VAlert>
      </VCard>
    </VFlex>
  </VLayout>
</template>

<script>
import { getInvoiceForExternalApproval, submitExternalApproval } from '../services/api';
import Viewer from '@/components/preview/Viewer.vue';

export default {
  name: 'ExternalApproval',
  components: { Viewer },
  data() {
    return {
      loading: true,
      error: null,
      invoice: null,
      processing: false,
      successMessage: null,
    };
  },

  async created() {
    this.$store.dispatch('setDrawerStateAction', false);
    try {
      const token = this.$route.query.token;
      if (!token) {
        this.error = 'Token ni bil podan.';
        return;
      }

      const response = await getInvoiceForExternalApproval(token);
      this.invoice = response.data;
    } catch (err) {
      console.error(err);
      this.error =
        'Napaka pri pridobivanju podatkov o dokumentu ali pa je bil dokument že potrjen.';
    } finally {
      this.loading = false;
    }
  },

  methods: {
    async handleApproval(approved) {
      this.processing = true;
      try {
        await submitExternalApproval({
          token: this.$route.query.token,
          approved,
        });

        this.successMessage = approved ? 'Document approved' : 'Document rejected';
      } catch (err) {
        console.error(err);
        this.error = 'Napaka pri procesiranju potrditve.';
      } finally {
        this.processing = false;
      }
    },
  },
};
</script>
